export { default as Status } from "./Status.vue";

import { useI18n } from "vue-i18n";

export const StatusTypes = Object.freeze({
    OPEN: "open",
    SCHEDULED: "scheduled",
    COMPLETED: "completed",
});

export function useStatuses() {
    const { t } = useI18n();

    const statuses = [
        {
            options: [
                {
                    id: StatusTypes.OPEN,
                    label: t("components.filters.status.open"),
                },
                {
                    id: StatusTypes.SCHEDULED,
                    label: t("components.filters.status.scheduled"),
                },
                {
                    id: StatusTypes.COMPLETED,
                    label: t("components.filters.status.completed"),
                },
            ],
        },
    ];

    return {
        statuses,
    };
}
